import { useCallback, useEffect, useRef, useState } from "react";
import { api, errMsg } from "../lib/api";
import { useLive } from "../context/LiveContext";

export function useApi(url, { live = true, params } = {}) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const seq = useRef(0);

  const load = useCallback(async (silent = false) => {
    if (!url) return;
    const n = ++seq.current;
    if (!silent) setLoading(true);
    try {
      const { data: d } = await api.get(url, { params: JSON.parse(key) });
      if (n === seq.current) { setData(d); setError(null); setStatus(200); }
    } catch (e) {
      if (n === seq.current) { setError(errMsg(e)); setStatus(e?.response?.status || 0); }
    } finally {
      if (n === seq.current) setLoading(false);
    }
  }, [url, key]);

  useEffect(() => { load(); }, [load]);
  useLive(() => { if (live) load(true); });

  return { data, error, status, loading, reload: load, setData };
}
